package interviewprep.client

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun Capability(label: String, value: String) {
    Div({ classes("capability") }) {
        Span { Text(label) }
        Span { Text(value) }
    }
}

internal fun entryDisplayText(entry: TimelineEntry): String =
    when (entry.role) {
        TimelineRole.INTERVIEWER -> cleanInterviewText(raw = entry.text, title = entry.detail)
        else -> entry.text
    }

@Composable
internal fun VoiceLoopStage(
    isSpeaking: Boolean,
    isListening: Boolean,
    isBusy: Boolean,
    sessionStarted: Boolean,
    speechEnabled: Boolean,
    liveSpeechText: String,
    captureStatus: String
) {
    val activeSpeaker = when {
        isSpeaking -> "ai"
        isListening -> "you"
        isBusy -> "ai"
        sessionStarted -> "you"
        else -> "ai"
    }
    val stageTitle = when {
        isSpeaking -> "Interviewer speaking"
        isListening -> "Listening to you"
        isBusy -> "Reviewing your answer"
        !speechEnabled -> "Voice unavailable"
        sessionStarted -> "Ready for your answer"
        else -> "Wait for the question"
    }
    val stageDetail = when {
        isSpeaking -> "Listen to the prompt. The microphone will open automatically after playback."
        isListening -> "Answer out loud. Voice Interview AI - SWE will auto-submit after your thought lands."
        isBusy -> "Voice Interview AI - SWE is preparing your coaching."
        !speechEnabled -> "Use a browser with speech recognition support to run the hands-free interview."
        sessionStarted -> "Tap Start speaking when you are ready."
        else -> "Start an interview, hear the prompt, then respond naturally."
    }

    Div({ classes("voice-loop-card") }) {
        Div({ classes("voice-loop-header") }) {
            Div {
                Span({ classes("eyebrow") }) { Text("Voice loop") }
                H2 { Text(stageTitle) }
                P { Text(stageDetail) }
            }
            Span({
                classes("mode-pill")
                if (speechEnabled) classes("on")
            }) {
                Text(if (speechEnabled) "Voice on" else "No mic")
            }
        }
        Div({ classes("participant-row") }) {
            ParticipantMeter(
                label = "You",
                sublabel = "Candidate",
                active = activeSpeaker == "you",
                side = "you"
            )
            Div({
                classes("voice-orb")
                if (isSpeaking || isListening || isBusy) classes("active")
            }) {
                Span { Text("Mic") }
            }
            ParticipantMeter(
                label = "AI",
                sublabel = "Interviewer",
                active = activeSpeaker == "ai",
                side = "ai"
            )
        }
        if (isListening || liveSpeechText.isNotBlank()) {
            P({ classes("live-caption") }) {
                Text(liveSpeechText.takeLast(160).ifBlank { captureStatus.takeIf { it.isNotBlank() } ?: "Listening..." })
            }
        }
    }
}

@Composable
private fun ParticipantMeter(label: String, sublabel: String, active: Boolean, side: String) {
    Div({
        classes("participant-meter", side)
        if (active) classes("active")
    }) {
        Div({ classes("speaker-label") }) {
            Span({ classes("speaker-dot") }) { Text("") }
            Div {
                Span({ classes("speaker-name") }) { Text(label) }
                Span({ classes("speaker-sublabel") }) { Text(sublabel) }
            }
        }
        Div({ classes("voice-bars") }) {
            repeat(9) { index ->
                Span({ classes("voice-bar", "bar-${index + 1}") }) { Text("") }
            }
        }
    }
}
